// extracted by mini-css-extract-plugin
export default {"root":"ZL4A4N","wrapper":"HcBlwg","aboveContentSlot":"QMlkG7","pageBottomSlot":"KPSGWw"};